import React from "react";
import { AiOutlineSearch } from "react-icons/ai";

const SearchOrder = ({ setSearchOrderIdInput, inputsValue, setInputValue }) => {
  const OnSubmit = (e) => {
    e.preventDefault();
    setSearchOrderIdInput(inputsValue);
  };
  return (
    <div className="order-search-pos-relative">
      <form onSubmit={OnSubmit}>
        <input
          type="text"
          value={inputsValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Use order id or name to search..."
          className="search-input-order"
        />
        <button type="submit" className="srch-order-btn">
          <AiOutlineSearch className="order-search-icon" />
        </button>
      </form>
    </div>
  );
};

export default SearchOrder;
